<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="4">
            <h1 class="header margin-top-xl">
              <chevron
                @click="$router.push({name: 'Workspace'})"/>
              {{ $t('menu.aggregateVariables') }}
            </h1>
          </grid-col>
        </grid-row>
        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="3">
            <div class="center-horizontal">
              <!-- Operations between constant variables  -->
                <safe-with-else-router-link to="/aggregate-variable/operated/list" class="nav__menu-item">
                  <div v-has-feature="'AggregateVariable'" class="personal-area-element">
                    <font-awesome-icon
                      :icon="icons.aggregateVariablesIcon"
                      class="personal-area-element-icon"/>
                    <div class="personal-area-element-title">{{ $t('aggregateVariable.constantVariables') }}</div>
                  </div>
                </safe-with-else-router-link>

              <!-- Over time gradual variable calculation -->
                <safe-with-else-router-link to="/aggregate-variable/gradual/list" class="nav__menu-item">
                  <div v-has-feature="'AggregateVariable'"  class="personal-area-element">
                    <font-awesome-icon
                      :icon="icons.aggregateGradualVariablesIcon"
                      class="personal-area-element-icon"/>
                    <div class="personal-area-element-title">{{ $t('aggregateVariable.gradualVariables') }}</div>
                  </div>
                </safe-with-else-router-link>

              <!-- Metrical variables -->
              <safe-with-else-router-link to="/aggregate-variable/metrical/list" class="nav__menu-item">
                <div v-has-feature="'AggregateVariable'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.aggregateMetricalVariablesIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('aggregateVariable.metricalVariables') }}</div>
                </div>
                <div slot="else" class="disabled personal-area-element">
                  <font-awesome-icon
                    :icon="icons.aggregateMetricalVariablesIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('aggregateVariable.metricalVariables') }}</div>
                </div>
              </safe-with-else-router-link>
            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faCalculatorAlt,
  faArrowsV,
  faIndustryAlt
} from '@fortawesome/pro-light-svg-icons';
import SafeRouterLink from '../../components/shared/SafeRouterLink';
import Chevron from '@/components/shared/Chevron';
import SafeWithElseRouterLink from '@/components/shared/SafeWithElseRouterLink';

export default {
  name: 'AggregateVariableMenu',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    SafeRouterLink,
    FontAwesomeIcon,
    Chevron,
    SafeWithElseRouterLink
  },
  data () {
    return {
      icons: {
        aggregateVariablesIcon: faCalculatorAlt,
        aggregateGradualVariablesIcon: faArrowsV,
        aggregateMetricalVariablesIcon: faIndustryAlt
      },
      breadcrumb: [
        {link: '/workspace', nameKey: 'menu.workspace'},
        {link: '/aggregate-variable/menu', nameKey: 'aggregateVariable.title', disabled: true}
      ]
    };
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb.map(route => {
        route.name = this.$t(route.nameKey);
        return route;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  h1 {
    display: block !important;
  }

  .personal-area-element {
    align-items: center;
    display: inline-block;
    text-align: center;
    background-color: $black-light9;
    border: solid 0.2rem $black-light9;
    border-radius: $radius;
    height: 15rem;
    width: 15rem;
    color: $secondary;
    margin: 1rem;
    padding-top: 2.7rem;
  }

  .personal-area-element:hover {
    border: solid 0.2rem $black-light5;
  }

  .personal-area-element-icon {
    font-size: 7rem;
  }

  .personal-area-element-title {
    font-size: 1.3rem;
    font-weight: bold;
    height: 3em;
    display: flex;
    justify-content: center;
  }

  .disabled, .disabled:hover{
    color: $secondary-trans7;
    border: solid 0.2rem $black-light9;
  }

  .center-horizontal {
    display: table;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/variables/AggregateVariableMenu.vue